import type { CurrentlyPlaying } from '@/types/api'

/** Version distribution as shares (largest first), folding the tail into "Other". */
export function versionShares(list: { version: string | null; count: number }[], max = 4): { label: string; count: number; share: number }[] {
  const total = list.reduce((n, v) => n + v.count, 0)
  if (total === 0) return []
  const sorted = [...list].sort((a, b) => b.count - a.count)
  const head = sorted.slice(0, max).map((v) => ({ label: v.version ?? 'Unknown', count: v.count }))
  const rest = sorted.slice(max).reduce((n, v) => n + v.count, 0)
  if (rest > 0) head.push({ label: 'Other', count: rest })
  return head.map((v) => ({ ...v, share: v.count / total }))
}

const MODE_LABELS: Record<NonNullable<CurrentlyPlaying['mode']>, string> = {
  normal: 'Scheduled',
  fallback: 'Default content',
  safe_mode: 'Safe mode',
  emergency: 'Emergency',
  unpaired: 'Unpaired',
  idle: 'Idle',
}

/** One line describing what a display is showing. */
export function playingSummary(p: CurrentlyPlaying): { title: string; detail: string } {
  const mode = p.mode ? MODE_LABELS[p.mode] : 'Unknown'
  if (p.mode === 'emergency') return { title: p.schedule?.name ?? 'Emergency broadcast', detail: mode }
  const title = p.slideshow?.name ?? (p.mode === 'idle' ? 'Nothing scheduled' : 'Unknown content')
  const detail = [p.campaign?.name, p.schedule?.name, mode].filter(Boolean).join(' · ')
  return { title, detail }
}
